<div class="ui-g mb-5 payment-information-container">
  <div class="ui-g-4 ui-sm-6 ui-md-6 ui-lg-4 ui-xl-4">
    <div class="card information-card mb-0">
      <div class="card-title">
        <div
          class="tile-head payment-title font-bold"
          aria-label="Partner criteria information">
          Partner criteria information
        </div>
      </div>
      <div class="card-body pt-2">
        <div class="ui-g">
          <div class="ui-g-12 ui-xl-6 mb-2 activity-font">
            <span class="font-bold payment-title" aria-label="Co-Sell Ready"
              ><i class="mdl2-cosell mr-2"></i>Co-Sell Ready</span
            ><br />
            @if (partnerPaymentDetails.partnerCriteriaInfo.isCoSellReady) {
              <div class="ml-4" aria-label="Yes">Yes</div>
            }
            @if (!partnerPaymentDetails.partnerCriteriaInfo.isCoSellReady) {
              <div class="ml-4" aria-label="No">No</div>
            }
          </div>
          <div class="ui-g-12 ui-xl-6 mb-2 activity-font">
            <span class="font-bold payment-title" aria-label="Fast Track Ready"
              ><i class="mdl2-fasttrack mr-2"></i>Fast Track Ready</span
            ><br />
            @if (partnerPaymentDetails.partnerCriteriaInfo.isFastTrackReady) {
              <div class="ml-4" aria-label="Yes">Yes</div>
            }
            @if (!partnerPaymentDetails.partnerCriteriaInfo.isFastTrackReady) {
              <div class="ml-4" aria-label="No">No</div>
            }
          </div>
          <div class="ui-g-12 ui-xl-6 mb-2 activity-font">
            <span
              class="font-bold payment-title"
              aria-label="Competency partner"
              ><i class="mdl2-competency mr-2"></i>Competency partner</span
            ><br />
            <div class="ml-4">
              {{ partnerPaymentDetails.partnerCriteriaInfo.competencyPartner }}
            </div>
          </div>
          <div class="ui-g-12 ui-xl-6 mb-2 activity-font">
            <span class="font-bold payment-title" aria-label="Azure Expert MSP"
              ><i class="mdl2-azure-expert mr-2"></i>Azure Expert MSP</span
            ><br />
            @if (partnerPaymentDetails.partnerCriteriaInfo.isAzureExpertMsp) {
              <div class="ml-4" aria-label="Yes">Yes</div>
            }
            @if (!partnerPaymentDetails.partnerCriteriaInfo.isAzureExpertMsp) {
              <div class="ml-4" aria-label="No">No</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-g-4 ui-sm-6 ui-md-6 ui-lg-4 ui-xl-4">
    <div class="card information-card mb-0">
      <form [formGroup]="payeeUpdateForm">
        <div class="card-title payeeedit">
          <div class="ui-g">
            <div class="ui-g-12 p-0">
              <div class="ui-g-10 p-0">
                <div
                  class="tile-head payment-title font-bold"
                  aria-label="Payment profile information">
                  Payment profile information
                </div>
              </div>
              <div class="ui-g-2 flex-pull-right">
                <span
                  class="fa fa-pencil ico cpointer fl-rt pen-for-white-glove"
                  pTooltip="Edit Payee Details"
                  tooltipposition="bottom"
                  tabindex="0"
                  (click)="editUpdatePayeeInfo()"
                  (keydown.enter)="editUpdatePayeeInfo()"></span>
              </div>
            </div>
            <div class="ui-g-12 pl-0">
              <div class="dropdown-align float-left">
                <p-select
                  [disabled]="isEditUpdatePayeeInfo"
                  [showClear]="false"
                  class="type-dropdown"
                  [options]="programTypes"
                  optionLabel="programName"
                  [(ngModel)]="selectedProgramType"
                  [ngModelOptions]="{ standalone: true }"
                  (onChange)="
                    onPaymentProfileProgramTypeChange($event)
                  "></p-select>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body pt-2">
          <div class="ui-g">
            <div class="ui-g-12 ui-xl-6 mb-2 activity-font">
              <span class="font-bold payment-title" aria-label="Payee name"
                ><i class="mdl2-payee-name mr-2"></i>Payee name</span
              ><br />
              <div class="ml-4">
                {{
                  partnerPaymentDetails.paymentProfileInfo.payeeName
                    ? partnerPaymentDetails.paymentProfileInfo.payeeName
                    : 'NA'
                }}
              </div>
            </div>
            <div class="ui-g-12 ui-xl-6 mb-2 activity-font">
              <span class="font-bold payment-title" aria-label="Vendor Id"
                ><i class="mdl2-expiry-date mr-2"></i>Vendor ID</span
              ><br />
              <span>
                <div class="ui-g-12">
                  <input
                    tabindex="0"
                    type="text"
                    class="edittext"
                    name="vendorid"
                    id="vendorid"
                    formControlName="vendorId"
                    required
                    [ngClass]="{
                      'error-box':
                        updatePayeeDetails['vendorId'].errors &&
                        this.updatePayeeDetails['vendorId'].touched
                    }"
                    autocomplete="off" />
                </div>
              </span>
            </div>
            <div class="ui-g-12 ui-xl-6 mb-2 activity-font">
              <span
                class="font-bold payment-title"
                aria-label="Payee contact email"
                ><i class="mdl2-payee-contact mr-2"></i>Payee contact
                email</span
              ><br />
              <div class="ml-4 email">
                {{
                  partnerPaymentDetails.paymentProfileInfo.payeeContactEmail
                    ? partnerPaymentDetails.paymentProfileInfo.payeeContactEmail
                    : 'NA'
                }}
              </div>
            </div>
            <div class="ui-g-12 ui-xl-6 mb-2 activity-font">
              <span class="font-bold payment-title" aria-label="Supplier ID"
                ><i class="mdl2-supplier-id mr-2"></i>Supplier ID</span
              ><br />
              <span>
                <div class="ui-g-12">
                  <input
                    tabindex="0"
                    type="text"
                    class="edittext"
                    name="supplierid"
                    id="supplierid"
                    formControlName="supplierId"
                    required
                    [ngClass]="{
                      'error-box':
                        updatePayeeDetails['supplierId.errors'] &&
                        this.updatePayeeDetails['supplierId'].touched
                    }"
                    autocomplete="off" />
                </div>
              </span>
            </div>
            @if (!isEditUpdatePayeeInfo) {
              <div class="ui-g-5"></div>
            }
          </div>
          <div class="ui-g mt-3">
            <div class="ui-g-12">
              <p
                class="font-s info-color"
                aria-label="Payee name is the name descriptor from Payment Central">
                Payee name is the name descriptor from Payment Central
              </p>
            </div>
            <div class="ui-g-12">
              <a [routerLink]="[]" (click)="showAddVendorDialog()"
                >Add New Vendor</a
              >
            </div>
          </div>
          @if (isEditUpdatePayeeInfo) {
            <div class="ui-g-12 payeesave">
              <button
                type="submit"
                [disabled]="payeeUpdateForm.invalid"
                pButton
                (click)="UpdatePayeeInfoDetails()"
                class="flat btnmr fl-rt">
                Save
              </button>
              <button
                type="button"
                pButton
                (click)="cancelEditUpdatePayeeInfo()"
                class="ui-button-secondary flat fl-rt">
                Cancel
              </button>
            </div>
          }
          @if (showResponse) {
            @for (message of msgsUsageDetails; track message) {
              <p-message [life]="3000" [text]="message.detail"></p-message>
            }
          }
        </div>
      </form>
    </div>
  </div>
  <div class="ui-g-4 ui-sm-6 ui-md-6 ui-lg-4 ui-xl-4">
    <div class="card information-card mb-0">
      <div class="card-title">
        <div class="tile-head payment-title font-bold" aria-label="Key Details">
          Key Details
        </div>
      </div>
      <div class="card-body pt-2">
        <div class="ui-g mb-2">
          <div class="ui-xl-7 ui-g-12 align-activity pl-0 pr-0 mb-1">
            <span
              class="activity-font font-bold payment-title align pr-2"
              aria-label="Payment profile"
              ><i class="mdl2-payment-profile mr-2"></i>Payment profile</span
            >
          </div>
          <div class="ui-xl-5 ui-g-12 activity-font">
            <div
              class="font-bold"
              aria-label="payment profile status"
              [ngClass]="
                getStyleForPaymentProfileStatus(
                  partnerPaymentDetails.paymentProfileStatusDescription
                )
              ">
              {{
                getPaymentProfileStatus(
                  partnerPaymentDetails.paymentProfileStatusDescription
                )
              }}
            </div>
          </div>
        </div>
        <div class="ui-g mb-2">
          <div class="ui-xl-7 ui-g-12 align-activity pl-0 pr-0 mb-1">
            <span
              class="activity-font font-bold payment-title align pr-2"
              aria-label="SSPA & anti-corruption">
              <i class="mdl2-sspa mr-2"></i>SSPA & anti-corruption</span
            >
          </div>
          <div class="ui-xl-5 ui-g-12 activity-font">
            @if (partnerPaymentDetails.sspaAndAntiCorruption) {
              <div class="font-bold green" aria-label="Green">Green</div>
            }
            @if (!partnerPaymentDetails.sspaAndAntiCorruption) {
              <div class="font-bold red" aria-label="Red">Red</div>
            }
          </div>
        </div>
      </div>
      <div class="card-title">
        <div class="tile-head payment-title font-bold" aria-label="Key Details">
          Program Agreements
          <div class="dropdown-align">
            <p-select
              [showClear]="false"
              class="type-dropdown"
              [options]="fiscalYear"
              optionLabel="fiscalYearName"
              [(ngModel)]="selectedFiscalYear"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Fiscal Year"
              (onChange)="filterTable($event)"></p-select>
          </div>
        </div>
      </div>
      <div class="card-body pt-2">
        <div class="ui-g mb-2">
          <div class="ui-xl-7 ui-g-12 align-activity pl-0 pr-0 mb-1">
            <span class="activity-font font-bold payment-title align pr-2"
              ><i class="mdl2-contract-status mr-2"></i>MCAP Program
              agreement</span
            >
          </div>
          <div class="ui-xl-5 ui-g-12 activity-font">
            @if (isMCAPAgreed) {
              <div class="font-bold green" aria-label="Green">Green</div>
            }
            @if (!isMCAPAgreed) {
              <div class="font-bold red" aria-label="Red">Red</div>
            }
          </div>
        </div>
        <div class="ui-g mb-2">
          <div class="ui-xl-7 ui-g-12 align-activity pl-0 pr-0 mb-1">
            <span class="activity-font font-bold payment-title align pr-2"
              ><i class="mdl2-contract-status mr-2"></i>Operator Program
              agreement</span
            >
          </div>
          <div class="ui-xl-5 ui-g-12 activity-font">
            @if (mcapFiscalYear) {
              <div class="font-bold red" aria-label="Red">N/A</div>
            }
            @if (isOperatorAgreed && !mcapFiscalYear) {
              <div class="font-bold green" aria-label="Green">Green</div>
            }
            @if (!isOperatorAgreed && !mcapFiscalYear) {
              <div class="font-bold red" aria-label="Red">Red</div>
            }
          </div>
        </div>
        <div class="ui-g mb-2">
          <div class="ui-xl-7 ui-g-12 align-activity pl-0 pr-0 mb-1">
            <span class="activity-font font-bold payment-title align pr-2"
              ><i class="mdl2-contract-status mr-2"></i>MSSP Program
              agreement</span
            >
          </div>
          <div class="ui-xl-5 ui-g-12 activity-font">
            @if (mcapFiscalYear) {
              <div class="font-bold red" aria-label="Red">N/A</div>
            }
            @if (isMSSPAgreed && !mcapFiscalYear) {
              <div class="font-bold green" aria-label="Green">Green</div>
            }
            @if (!isMSSPAgreed && !mcapFiscalYear) {
              <div class="font-bold red" aria-label="Red">Red</div>
            }
          </div>
        </div>
        <div class="ui-g mb-2">
          <div class="ui-xl-7 ui-g-12 align-activity pl-0 pr-0 mb-1">
            <span class="activity-font font-bold payment-title align pr-2"
              ><i class="mdl2-contract-status mr-2"></i>Events Program
              agreement</span
            >
          </div>
          <div class="ui-xl-5 ui-g-12 activity-font">
            @if (mcapFiscalYear) {
              <div class="font-bold red" aria-label="Red">N/A</div>
            }
            @if (isEventAgreed && !mcapFiscalYear) {
              <div class="font-bold green" aria-label="Green">Green</div>
            }
            @if (!isEventAgreed && !mcapFiscalYear) {
              <div class="font-bold red" aria-label="Red">Red</div>
            }
          </div>
        </div>
        <div class="ui-g mb-2">
          <div class="ui-xl-7 ui-g-12 align-activity pl-0 pr-0 mb-1">
            <span class="activity-font font-bold payment-title align pr-2"
              ><i class="mdl2-contract-status mr-2"></i>MSAI Program
              agreement</span
            >
          </div>
          <div class="ui-xl-5 ui-g-12 activity-font">
            @if (mcapFiscalYear) {
              <div class="font-bold red" aria-label="Red">N/A</div>
            }
            @if (isMSAIPAgreed && !mcapFiscalYear) {
              <div class="font-bold green" aria-label="Green">Green</div>
            }
            @if (!isMSAIPAgreed && !mcapFiscalYear) {
              <div class="font-bold red" aria-label="Red">Red</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-add-vendor #addVendorComponent></app-add-vendor>
</div>
